/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'window',
    'pip-event-manifest'
],
function(
    window,
    eventManifest
){

    var events = {};
    window.PIP_EVENTS = events;

	function EventBroker(type) {
        this.type = type;
        this.subscribers = {
            callbacks: []
        };
    };

    EventBroker.prototype.on = function on(namespace, callback) {
        // if namespace, do what we're doing now.
        // otherwise, just push the event onto an array --
        if (namespace === 'callbacks') {
            throw "PIP EVENTS: The namespace 'callbacks' is a reserved name (" + this.type + namespace + ")";
        }
        if (typeof namespace === 'function') {
            this.subscribers.callbacks.push(namespace);
            return;
        }
        if (typeof namespace !== 'string') {
            throw "PIP EVENTS: Namespace should be provided as first argument for event " + this.type;
        }
        if (this.subscribers[namespace]) {
            throw "PIP EVENTS: An event under the namespace '" + namespace + "' already exists";
        }

        this.subscribers[namespace] = callback;
	};

    EventBroker.prototype.off = function off(namespace) {
        if (typeof namespace !== 'string') {
            this.subscribers.callbacks = [];
            return;
        }
        return delete this.subscribers[namespace];
    };

	EventBroker.prototype.trigger = function trigger(data) {
        var keys = Object.keys(this.subscribers);
        for (var i=0; i < keys.length; i++) {
            var keyName = keys[i];
            if (keyName === 'callbacks') continue;
            var subscriber = this.subscribers[keyName];
            subscriber(this.type, data);
        }
        for (var i=0; i < this.subscribers.callbacks.length; i++) {
            this.subscribers.callbacks[i](this.type, data);
        }
	};

    function initEvents() {
        for(var a = 0; a < eventManifest.events.length; a++) {
            var eventCategory = Object.keys(eventManifest.events[a]);
            var eventList;

            for(var b = 0; b < eventCategory.length; b++) {
                eventList = eventManifest.events[a][eventCategory[b]];
            }

            events[eventCategory] = {};

            for(var c = 0; c < eventList.length; c++) {
                var eventName = eventList[c];
                events[eventCategory][eventName] = new EventBroker(eventName);
            }
        }
    }


    // TODO: Better name than PipLifecycleEvents?
    events.pipLifecycleEvents = {};

    function PipLifecycleEventBroker(type) {
        this.type = type;
        this.subscribers = {
            callbacks: []
        };
        // TODO: Stylistic question: Init with undefined, null, or don't mention promise here at all since we just
        // don't have one yet.  On the one hand, we expect this broker type to be promise-based which is a point
        // for mentioning it here.  On the other hand, it looks a little awkward to explicitly init a member to
        // undefined or null.
        this.promise = null;
    }

    PipLifecycleEventBroker.prototype.on = function onPipLifecycleEvent(onResolved) {
        if (this.promise) {
            this.promise.then(onResolved);
        } else {
            this.subscribers.callbacks.push({ onResolved: onResolved });
        }
    };

    PipLifecycleEventBroker.prototype.off = function offPipLifecycleEvent() {
        this.subscribers.callbacks = [];
        this.promise = null;
    };

    PipLifecycleEventBroker.prototype.trigger = function triggerPipLifecycleEvent(data) {
        if (this.promise) { return; }

        this.promise = new Promise(function (resolve) {
            resolve(data);
        });

        for (var i = 0; i < this.subscribers.callbacks.length; i++) {
            this.promise.then(this.subscribers.callbacks[i].onResolved);
        }
    };

    function initPipLifecycleEvents() {
        for(var a = 0; a < eventManifest.pipLifecycleEvents.length; a++) {
            var eventCategory = Object.keys(eventManifest.pipLifecycleEvents[a]);
            var eventList;

            for(var b = 0; b < eventCategory.length; b++) {
                eventList = eventManifest.pipLifecycleEvents[a][eventCategory[b]];
            }

            events.pipLifecycleEvents[eventCategory] = {};

            for(var c = 0; c < eventList.length; c++) {
                var eventName = eventList[c];
                events.pipLifecycleEvents[eventCategory][eventName] = new PipLifecycleEventBroker(eventName)
            }
        }
    }

    initEvents();
    initPipLifecycleEvents();

	return events;
});

}.call(window));